import { get, post } from '../../../../services/request';

export const fetchProviderRequests = (payload) =>
    post('ProviderRequest/GetAllProviderRequests', payload);

export const fetchProviderRequestDropdowns = () =>
    get('ProviderRequest/GetProviderRequestDropdowns');

export const updateProviderRequestStatus = (payload) =>
    post('ProviderRequest/UpdateProviderRequestStatus', payload);

export const bulkUpdateProviderRequestTask = (payload) =>
    post('ProviderRequest/BulkUpdateProviderRequestTask', payload);

export const saveSchedulingCalendarAdhocShifts = (payload) =>
    post('SchedulingCalendar/SaveAdhocShifts', payload);

export const scheduleRequestTransaction = (payload) =>
    post('RadRequest/ScheduleRequestTransaction', payload);
